import { api } from "@/lib/api";
import { usePolling } from "@/hooks/usePolling";
import { BenchmarkTriple } from "@/components/data/BenchmarkTriple";

export default function Carbon() {
  const { data, error } = usePolling(() => api.get("/intelligence/carbon").then((r) => r.data), 5000);
  const sustain = usePolling(() => api.get("/intelligence/sustainability").then((r) => r.data), 5000).data;

  if (error) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="carbon-error">Could not load carbon layer.</div>;
  if (!data) return <div className="text-sm text-[var(--oim-text-muted)]" data-testid="carbon-loading">Loading…</div>;

  return (
    <div className="space-y-4" data-testid="carbon-page">
      <h1 className="text-2xl font-bold font-heading text-[var(--oim-text)]">Carbon & Passport</h1>
      <div className="text-[10px] text-[var(--oim-text-dim)]" data-testid="pcf-scope-notice">
        Operational Product Carbon Footprint (Scope 1 + 2 + material Scope 3 from plant operations) — not a full cradle-to-gate footprint; upstream supplier-specific data is represented by configured emission factors.
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="rounded-xl border p-4" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
          <BenchmarkTriple label="Carbon intensity" unit={data.carbon_intensity.unit} {...data.carbon_intensity} testId="benchmark-carbon-intensity" />
        </div>
        <div className="rounded-xl border p-4 space-y-2 font-mono-data text-sm" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
          <div className="flex justify-between"><span className="text-[var(--oim-text-muted)]">Scope 1 (process)</span><span className="text-[var(--oim-text)]">{data.scope1_kg_per_hr} kg/hr</span></div>
          <div className="flex justify-between"><span className="text-[var(--oim-text-muted)]">Scope 2 (electricity)</span><span className="text-[var(--oim-text)]">{data.scope2_kg_per_hr} kg/hr</span></div>
        </div>
        {sustain && (
          <div className="rounded-xl border p-4 md:col-span-2" style={{ borderColor: "var(--oim-border)", backgroundColor: "var(--oim-surface)" }}>
            <BenchmarkTriple label="Byproduct valorization rate" unit={sustain.byproduct_valorization_rate.unit} {...sustain.byproduct_valorization_rate} testId="benchmark-valorization-rate" />
          </div>
        )}
      </div>
    </div>
  );
}
